import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ko from './locales/ko.json';

const browserLanguage = navigator.language || navigator.userLanguage;
const getDefLang = () => {
    const lang = browserLanguage.split('-')[0]
    return "ko,en".includes(lang) ? lang : 'en'
}
const savedLanguage = getDefLang();

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: en,
        },
        ko: {
            translation: ko,
        }
    },
    lng: getDefLang(), // Default language
    fallbackLng: 'en', // Fallback language
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
});

export function getCurrentLangugage(){
    return i18n.language
}
export default i18n;
